/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type InterruptTurnResult = {
  /**
   * How many turns were dropped from the conversation's queue before any runtime claimed them.
   */
  cancelledQueued: number;
  /**
   * Whether a turn in flight on the assistant runtime was cancelled.
   */
  interrupted: boolean;
  /**
   * Whether the call stopped anything. False means nothing was generating — the reply had already finished, or the conversation never started a turn.
   */
  stopped: boolean;
};

/** @internal */
export const InterruptTurnResult$inboundSchema: z.ZodMiniType<
  InterruptTurnResult,
  unknown
> = z.pipe(
  z.object({
    cancelled_queued: z.int(),
    interrupted: z.boolean(),
    stopped: z.boolean(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "cancelled_queued": "cancelledQueued",
    });
  }),
);

export function interruptTurnResultFromJSON(
  jsonString: string,
): SafeParseResult<InterruptTurnResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => InterruptTurnResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'InterruptTurnResult' from JSON`,
  );
}
